import { EnergyTypeIconProps } from './types'
import styles from './EnergyTypeIcon.module.scss'
import { Icon } from '@boltenergy-be/design-system'
import { ENERGY_TYPE_ICONS } from './EnergyTypeIcon.constants'

const EnergyTypeIcon = ({ energyType, className }: EnergyTypeIconProps) => {
  return <Icon className={className || styles.icon} name={ENERGY_TYPE_ICONS[energyType]} />
}

export default EnergyTypeIcon
